import { Stack } from 'components/Stack';
import { useDetectDevice } from 'hooks';
import { CustomText } from 'components/CustomText';
import { useTranslation } from 'react-i18next';
import {
  IndicatorContainer,
  Seperator,
  StepContainer,
  StepIndx,
  StepSubText,
  StepTitle,
} from './Stepper.styles';
import { StepIndicator } from '../StepIndicator';

interface StepperInterfaceProps {
  steps: Array<{
    title: string;
    subText: string;
    customText?: string;
  }>;
}

export const Stepper = ({ steps }: StepperInterfaceProps) => {
  const { isDesktop } = useDetectDevice();
  const { t } = useTranslation();

  return (
    <Stack gap={16} direction={`${isDesktop ? 'row' : 'column'}`} isFullWidth>
      {steps.map((step, index) => {
        const stepIndx = index + 1;
        return (
          <StepContainer
            key={stepIndx}
            direction={`${isDesktop ? 'column' : 'row'}`}
          >
            <IndicatorContainer
              direction={`${isDesktop ? 'row' : 'column'}`}
              justify={`${isDesktop ? 'center' : 'flex-start'}`}
              align="center"
              isFullWidth={isDesktop}
              gap={isDesktop ? 16 : 8}
            >
              <StepIndicator />
              <Seperator />
            </IndicatorContainer>
            <Stack direction="column" gap={8} wrap>
              <StepIndx>
                {t('RETURN_STEP_X', { stepNumber: stepIndx })}
              </StepIndx>
              {step.customText ? (
                <CustomText text={step.customText} />
              ) : (
                <>
                  <StepTitle>{step.title}</StepTitle>
                  <StepSubText>{step.subText}</StepSubText>
                </>
              )}
            </Stack>
          </StepContainer>
        );
      })}
    </Stack>
  );
};
